import { Component, input } from '@angular/core';

@Component({
    selector: 'app-menu-header',
    templateUrl: './menu-header.component.html',
    styleUrls: ['./menu-header.component.css'],
})
export class MenuHeaderComponent {
    label = input.required<string>();
}
